import { gql } from '@apollo/client';
import { EXPORT_INSTITUTION } from '../../fragments';

export const EXPORT_FUNDER_TEST_SCHOOLS = gql`
  query ExportFunderTestSchools($input: ExportArgs!) {
    allFunderTestSchools(input: $input) {
      ...exportInstitution
    }
  }
  ${EXPORT_INSTITUTION}
`;
